import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from '@/store';
import { router } from '@/routes';
import { Toaster } from '@zawarski/eti-ui';
import { ThemeProvider } from '@/hooks/useThemeQuery';
import ScriptsLoader from '@/utils/ScriptsLoader';

function AppContent() {
  return (
    <div
      id='edma-root'
      style={{ margin: 0, height: '100%', width: '100%', backgroundColor: 'white' }}>
      <ScriptsLoader />
      <Provider store={store}>
        <Toaster richColors position='top-right' />
        <RouterProvider router={router} />
      </Provider>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
